import { createAction, props } from '@ngrx/store';
import { IReprocessPaymentParams, IReprocessPaymentResponse } from '../dto/pyament-run.dto';

export const loadPaymentReprocesss = createAction(
  '[PaymentReprocess] Load PaymentReprocesss',
  props<{ params: IReprocessPaymentParams; businessId: string }>()
);

export const loadPaymentReprocesssSuccess = createAction(
  '[PaymentReprocess] Load PaymentReprocesss Success',
  props<{ response: IReprocessPaymentResponse }>()
);

export const loadPaymentReprocesssFailure = createAction(
  '[PaymentReprocess] Load PaymentReprocesss Failure',
  props<{ error: Error | any }>()
);
